module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "CouponVerificationView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CouponVerificationView!./src/pages/Shop/Member/Wallet/Coupon/CouponVerification/index.js
// module id = 2020
// module chunks = 367